import { render, staticRenderFns } from "./VerticalStepBar.vue?vue&type=template&id=65fdafd5&"
import script from "./VerticalStepBar.vue?vue&type=script&lang=js&"
export * from "./VerticalStepBar.vue?vue&type=script&lang=js&"
import style0 from "./VerticalStepBar.vue?vue&type=style&index=0&id=65fdafd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports